import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

type SwitchFn = (subUserAccountId: string | null) => Promise<void> | void;

export const useSubUserFromQuery = (switchUser: SwitchFn) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const handledRef = useRef<string | null>(null);

  useEffect(() => {
    const hasSubUserAccountId = searchParams.has('subUserAccountId');

    if (!hasSubUserAccountId) return;

    const raw = searchParams.get('subUserAccountId');

    if (handledRef.current === raw) return;
    handledRef.current = raw;

    (async () => {
      try {
        await switchUser(raw === 'null' ? null : raw);
      } finally {
        // прибираємо query з URL після спроби свічу
        setSearchParams(
          (prev) => {
            const next = new URLSearchParams(prev);
            next.delete('subUserAccountId');
            return next;
          },
          { replace: true },
        );
      }
    })();
  }, [searchParams, setSearchParams, switchUser]);
};
